import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const WrenchIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={className}
        data-testid={testId}
        fill='none'
        height='30'
        viewBox='93 59 286 286'
        width='30'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            clipRule='evenodd'
            d='M325 70 L311 66 L299 65 L281 67 L258 77 L243 90 L236 99 L229 113 L225 128 L225 150 L228 161 L105 284 L99 296 L99 313 L103 323 L112 333 L125 339 L141 339 L149 336 L155 332 L277 210 L288 213 L309 213 L321 210 L337 203 L354 189 L366 171 L372 152 L372 127 L367 112 L321 157 L305 157 L281 133 L281 116 L326 72 Z M132 283 L144 284 L152 291 L155 297 L155 306 L153 310 L148 316 L140 320 L133 320 L125 316 L120 310 L118 305 L118 297 L121 291 L126 286 Z'
            fill='currentColor'
            fillRule='evenodd'
        />
    </svg>
);

export default WrenchIcon;
